import { render, staticRenderFns } from "./FiltersForMyCollections.vue?vue&type=template&id=4c9926ca&scoped=true&"
import script from "./FiltersForMyCollections.vue?vue&type=script&lang=js&"
export * from "./FiltersForMyCollections.vue?vue&type=script&lang=js&"
import style0 from "./FiltersForMyCollections.vue?vue&type=style&index=0&id=4c9926ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9926ca",
  null
  
)

export default component.exports